<template>
  <section class="aidrama-box4">
    <!-- Pixso 5:1 part4 — 393×600@1×；rem = @1× px × 2 -->
    <img
      class="aidrama-box4__bg"
      :src="part4Bg"
      alt=""
      aria-hidden="true"
    />
    <div class="aidrama-box4__inner">
      <header class="aidrama-box4__head">
        <h2 class="aidrama-box4__title">课程优势</h2>
        <p class="aidrama-box4__sub">实训衔接商单，学习同步增收</p>
      </header>

      <div class="aidrama-box4__visual">
        <img
          class="aidrama-box4__scene"
          :src="part4Scene"
          alt=""
          loading="lazy"
          decoding="async"
          aria-hidden="true"
        />

        <article class="aidrama-box4-card aidrama-box4-card--order">
          <h3 class="aidrama-box4-card__title">
            与多家AI漫剧公司达成订单合作
          </h3>
          <p class="aidrama-box4-card__desc">优秀者进入合作企业工作</p>
        </article>

        <article class="aidrama-box4-card aidrama-box4-card--train">
          <h3 class="aidrama-box4-card__title">
            学习期间跟老师一起做商业订单
          </h3>
          <p class="aidrama-box4-card__desc">
            分组进行AIGC漫剧制作订单制作赚取订单佣金
          </p>
        </article>

        <article class="aidrama-box4-card aidrama-box4-card--platform">
          <h3 class="aidrama-box4-card__title">自研一站式AIGC创意平台</h3>
          <p class="aidrama-box4-card__desc">聚合主流AIGC工具算力扶持</p>
        </article>
      </div>

      <button type="button" class="aidrama-box4__cta" @click="handleCtaClick">
        <span class="aidrama-box4__cta-text">立即申请试学</span>
        <img class="aidrama-box4__cta-arrow" :src="btnArrow" alt="" />
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "AidramaBox4",
  data() {
    return {
      part4Bg: require("../../../assets/coursePage/aidrama/box4/part4_bg.jpg"),
      part4Scene: require("../../../assets/coursePage/aidrama/box4/part4_scene.png"),
      btnArrow: require("../../../assets/coursePage/aidrama/box4/btn_arrow.png"),
    };
  },
  methods: {
    handleCtaClick() {
      qimoChatClick();
      if (window.zhuge) {
        window.zhuge.track("点击_传智AI漫剧页-第4屏-立即申请试学", {
          终端: "H5",
          名称: "传智AI漫剧页-第4屏-立即申请试学",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">

.aidrama-box4 {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 1);
}

.aidrama-box4__bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  object-fit: cover;
  object-position: center;
  transform: rotateY(180deg) rotateX(180deg);
  opacity: 0.18;
  pointer-events: none;
}

.aidrama-box4__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 80px 24px 116px;
  box-sizing: border-box;
}

/* 5:6 gap 6px */
.aidrama-box4__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.aidrama-box4__title {
  margin: 0;
  width: 100%;
  font-size: 48px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(79, 86, 255, 1);
  white-space: nowrap;
}

.aidrama-box4__sub {
  margin: 0;
  width: 100%;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(64, 69, 77, 1);
}

/* 5:9 / 5:12 / 5:33 + 5:36 — 视觉区 148~492@1× */
.aidrama-box4__visual {
  position: relative;
  width: 100%;
  height: 640px;
  margin-top: 84px;
  box-sizing: border-box;
}

.aidrama-box4__scene {
  position: absolute;
  left: 50%;
  top: 112px;
  width: 460px;
  height: 422px;
  transform: translateX(-50%);
  object-fit: contain;
  pointer-events: none;
}

.aidrama-box4-card {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 40px;
  box-sizing: border-box;
  border-radius: 24px;
}

.aidrama-box4-card__title {
  margin: 0;
  font-size: 26px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 2px;
  color: rgba(51, 51, 51, 1);
}

.aidrama-box4-card__desc {
  margin: 0;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 2px;
  color: rgba(102, 102, 102, 1);
}

/* 5:9 — 142×80；left 12 top 148 */
.aidrama-box4-card--order {
  left: 0;
  top: -20px;
  width: 284px;
  align-items: flex-end;
  background: linear-gradient(
    90deg,
    rgba(204, 230, 255, 1) 0%,
    rgba(213, 252, 255, 1) 100%
  );
}

.aidrama-box4-card--order .aidrama-box4-card__title,
.aidrama-box4-card--order .aidrama-box4-card__desc {
  width: 208px;
  text-align: right;
}

/* 5:12 — 142×95；left 240 top 133 */
.aidrama-box4-card--train {
  right: 0;
  top: -50px;
  width: 284px;
  align-items: flex-start;
  background: linear-gradient(
    270deg,
    rgba(204, 230, 255, 1) 0%,
    rgba(213, 252, 255, 1) 100%
  );
}

.aidrama-box4-card--train .aidrama-box4-card__title,
.aidrama-box4-card--train .aidrama-box4-card__desc {
  width: 208px;
  text-align: left;
}

/* 5:33 — left 78 top 415 */
.aidrama-box4-card--platform {
  left: 50%;
  top: 534px;
  transform: translateX(-50%);
  align-items: center;
  padding: 16px 60px;
  background: linear-gradient(
    0deg,
    rgba(204, 230, 255, 1) 0%,
    rgba(213, 252, 255, 0) 100%
  );
}

.aidrama-box4-card--platform .aidrama-box4-card__title,
.aidrama-box4-card--platform .aidrama-box4-card__desc {
  text-align: center;
  white-space: nowrap;
}

/* 5:3 top 492 */
.aidrama-box4__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 58px;
  padding: 40px 60px 40px 72px;
  box-sizing: border-box;
  border: none;
  border-radius: 24px;
  box-shadow: inset 0 0 22px rgba(255, 255, 255, 1);
  background: linear-gradient(
    270deg,
    rgba(188, 117, 255, 1) 0%,
    rgba(117, 104, 255, 1) 100%
  );
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.aidrama-box4__cta-text {
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 4px;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box4__cta-arrow {
  display: block;
  width: 12px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  opacity: 0.4;
}
</style>
